import React from 'react';
import { Tag } from 'shared/components';
import { TagColorType } from 'shared/components/Tag';
import { BillingNotesStatus } from 'views/AccountReceive/common/model/billingNoteStatus.model';

type TagStatusBillingNoteProps = {
  status: BillingNotesStatus;
};

const getTextColorStatus = (
  status: BillingNotesStatus,
): {
  color: TagColorType | undefined;
  text: string | number;
  outline: boolean;
} => {
  switch (status) {
    case 1:
      return { color: 'blue', text: 'รอวางบิล', outline: false };
    case 2:
      return { color: 'blue', text: 'รอรับชำระ', outline: false };
    case 3:
      return { color: 'red--light', text: 'แก้ไข', outline: false };
    case 5:
      return { color: 'red', text: 'ยกเลิก', outline: false };
    case 6:
      return { color: 'green', text: 'ชำระแล้ว', outline: false };
    default:
      return { color: undefined, text: status, outline: false };
  }
};

const TagStatusBillingNote: React.FC<TagStatusBillingNoteProps> = (props) => {
  const { status } = props;
  const textColor = getTextColorStatus(status);

  return (
    <Tag customColor={textColor.color} outline={textColor.outline}>
      {textColor.text}
    </Tag>
  );
};

export default TagStatusBillingNote;
